module.exports = __webpack_public_path__ + "static/media/logo.604c9371.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 744
// module chunks = 0 1